import { initializeApp } from "firebase/app";
import { getAuth, signOut, signInWithEmailAndPassword } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";

const config = {
  apiKey: "AIzaSyCNbtXewRSALQzNE-V3HD8PplTSu_XC9Ys",
  authDomain: "solplay-3a416.firebaseapp.com",
  projectId: "solplay-3a416",
  storageBucket: "solplay-3a416.firebasestorage.app",
  messagingSenderId: "723924586724",
  appId: "1:723924586724:web:a1f4f70e061729a2535cf1",
  measurementId: "G-F74CPBTQWJ",
};

const app = initializeApp(config);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const functions = getFunctions(app);

export const login = async (email, password) => {
  try {
    await signInWithEmailAndPassword(auth, email, password);
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export const logOut = async () => {
  await signOut(auth);
};
